import { buildNativeAppUrl } from "@/modules/auth/native-app";

export const IOS_APP_STORE_URL = "https://apps.apple.com/ru/app/meridianhub-chat/id6760617850";
export const ANDROID_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=ru.meridianhub.chat";

export function buildMobileAppDeepLink(path = "/") {
  return buildNativeAppUrl(path);
}
